export default function transitionEmit({ swiper, runCallbacks, direction, step }) {
  const { activeindex, previousindex } = swiper;
  let dir = direction;
  if (!dir) {
    if (activeindex > previousindex) dir = 'next';
    else if (activeindex < previousindex) dir = 'prev';
    else dir = 'reset';
  }

  swiper.emit(`transition${step}`);

  if (runCallbacks && activeindex !== previousindex) {
    if (dir === 'reset') {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }
    swiper.emit(`slideChangeTransition${step}`);
    if (dir === 'next') {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}
